import moment from "moment";
import DealHighlightTypes from "@irati-web/perks/src/constants/dealHighlightTypes";
export default function isTimeLimited(deal) {
    return !!deal.isValidFor24Hours;
}
export function getTimeLimitedType(deal) {
    if (isTimeLimited(deal)) {
        return DealHighlightTypes.TIME_LIMIT_24_HOUR;
    }
    return deal.typeHighlight;
}
export function getFakeExpiryDate(redemption) {
    return moment(redemption.date).add(1, "day");
}
export function hasRedemptionExpired(redemption) {
    if (!isTimeLimited(redemption.deal)) {
        return false;
    }
    var now = moment();
    var expiresAt = getFakeExpiryDate(redemption);
    return now > expiresAt;
}
